export const CERTIFICATE_HEADERS = [
    {
        text: "ID",
        value: "certid",
        width: "3rem"
    },
    {
        text: "Certificate serial number",
        shortText: "Serial number",
        value: "certificateserialnumber",
        width: "20rem",
        defaultVisible: true,
    },
    {
        text: "Subject",
        value: "subject",
        sortable: false,
        width: "14rem",
        defaultVisible: true,
    },
    {
        text: "Subject type",
        value: "subjectType",
        orderBy: "certtype",
        width: "7rem",
    },
    {
        text: "Issuer",
        value: "issuer",
        sortable: false,
        width: "14rem",
    },
    {
        text: "Status",
        value: "status",
        sortable: false,
        width: "5rem",
        defaultVisible: true,
    },
    {
        text: "Revocation reason",
        value: "reason",
    },
    {
        text: "Revoked at",
        value: "revocationtime",
        width: "14rem",
    },
    {
        text: "Valid from",
        value: "validfrom",
        width: "10rem",
        defaultVisible: true,
    },
    {
        text: "Valid to",
        value: "validto",
        width: "10rem",
        defaultVisible: true,
    },
    {
        text: "Total lifespan",
        value: "totalLifespan",
        sortable: false,
        width: "15rem",
    },
    {
        text: "Time to expiry",
        value: "timeToExpire",
        orderBy: "validto",
        width: "10rem",
        defaultVisible: true,
    },
    {
        text: "Lifespan",
        value: "lifespan",
        sortable: false,
        width: "5rem",
        defaultVisible: true,
    },
    {
        value: "actions",
        sortable: false,
        width: "2rem",
        defaultVisible: true,
        required: true,
        draggable: false
    },
].map((header) => {
    return {
        sortable: true,
        divider: true,
        text: "",
        shortText: header.text || "",
        orderBy: header.value,
        defaultVisible: false,
        required: false,
        draggable: true,
        ...header,
    };
});
